<template>
    <div class="notice-edit min-height padding">
        <el-form
            :model="noticeForm"
            :rules="rules"
            ref="noticeForm"
            label-width="140px"
            class="demo-noticeForm"
        >
            <el-form-item label="通知标题" prop="title">
                <el-input
                    v-model="noticeForm.title"
                    placeholder="请输入通知标题"
                ></el-input>
            </el-form-item>
            <el-form-item label="通知类型" prop="notice_type">
                <el-radio-group v-model="noticeForm.notice_type">
                    <el-radio :label="1" :disabled="noticeId !== 0">普通通知</el-radio>
                    <el-radio :label="2" :disabled="noticeId !== 0">反馈通知</el-radio>
                    <el-radio :label="3" :disabled="noticeId !== 0">报名通知</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="通知文本" prop="content">
                <VueUditorWrap
                    v-model="noticeForm.content"
                    :config="myConfig"
                ></VueUditorWrap>
            </el-form-item>
            <el-form-item label="通知附件">
                <el-upload
                    ref="upload3"
                    :action="udhost + '/api/index/upload'"
                    :name="'file'"
                    multiple
                    :data="fileData"
                    :file-list="fileList3"
                    :on-preview="handlePreview"
                    :on-success="handleAvatarSuccess3"
                >
                    <div class="flex align-center">
                        <el-button type="primary" plain> + 点击上传附件</el-button>
                    </div>
                </el-upload>
            </el-form-item>

            <el-form-item label="发送会员" prop="send2user" v-if="!noticeId">
                <el-button type="primary" class="margin-right" v-if="!allChiose" @click="chioseDialog = true">
                    {{ noticeForm.send2user.length === 0 ? '会员选择' : '已选择' + noticeForm.send2user.length + '家会员' }}
                </el-button>
                <el-checkbox v-model="allChiose">全部会员</el-checkbox>
            </el-form-item>
            <el-row :gutter="20">
                <el-col :span="6">
                    <el-form-item
                        label="总报名人数限制"
                        prop="delivery"
                        v-if="noticeForm.notice_type === 3 "
                    >
                        <el-switch v-model="noticeForm.delivery"></el-switch>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="noticeForm.delivery">
                    <el-form-item
                        label="限制人数"
                        prop="total"
                        v-if="noticeForm.notice_type === 3 "
                    >
                        <el-input-number v-model="noticeForm.total" :min="1" label="限制人数至少1人"></el-input-number>
                    </el-form-item>
                </el-col>
            </el-row>


            <el-form-item
                label="企业报名人数限制"
                prop="signup_num"
                v-if="noticeForm.notice_type === 3 && noticeId === 0"
            >
                <el-radio-group v-model="noticeForm.signup_num">
                    <el-radio :label="1">1人</el-radio>
                    <el-radio :label="2">2人</el-radio>
                    <el-radio :label="3">3人</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item
                label="是否短信通知"
                prop="is_send_sms"
                v-if="noticeForm.notice_type === 3 && noticeId === 0"
            >
                <el-radio-group v-model="noticeForm.is_send_sms">
                    <el-radio :label="0">否</el-radio>
                    <el-radio :label="1">是</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="报名表" v-if="noticeForm.notice_type === 3 && noticeId === 0">
                <el-table
                    :data="noticeForm.diy_form"
                    header-row-class-name="table-header"
                    row-class-name="table-row"
                    alig="center"
                    fit
                    style="width: 100%"
                >
                    <el-table-column label="表单项">
                        <template slot-scope="scope">
                            <div
                                class="table-item padding-left-sm flex align-center"
                                v-if="Number(scope.row.type) === 1"
                            >
                                <p>
                  <span v-if="Number(scope.row.state) === 1">*</span
                  >{{ scope.row.name }}:
                                </p>
                                <input type="text" :placeholder="scope.row.placeholder"/>
                            </div>
                            <div
                                class="table-item padding-left-sm flex align-start"
                                v-if="Number(scope.row.type) === 2"
                            >
                                <p>
                  <span v-if="Number(scope.row.state) === 1">*</span
                  >{{ scope.row.name }}:
                                </p>
                                <textarea :placeholder="scope.row.placeholder"></textarea>
                            </div>
                            <div
                                class="table-item padding-left-sm"
                                v-if="Number(scope.row.type) === 3"
                            >
                                <p>
                  <span v-if="Number(scope.row.state) === 1">*</span
                  >{{ scope.row.name }}
                                </p>
                                <div class="flex align-center flex-wrap">
                  <span
                      class="flex align-center margin-right"
                      v-for="items in scope.row.option"
                      :key="items"
                  >
                    <input type="radio" disabled class="radio"/><span
                      class="margin-left-xs"
                  >{{ items }}</span
                  >
                  </span>
                                </div>
                            </div>
                            <div
                                class="table-item padding-left-sm"
                                v-if="Number(scope.row.type) === 4"
                            >
                                <p>
                  <span v-if="Number(scope.row.state) === 1">*</span
                  >{{ scope.row.name }}
                                </p>
                                <div class="flex align-center flex-wrap">
                  <span
                      class="flex align-center margin-right"
                      v-for="items in scope.row.option"
                      :key="items"
                  >
                    <input type="checkbox" disabled class="radio"/>
                    <span class="margin-left-xs">{{ items }}</span>
                  </span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="类型" width="100px">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ scope.row.type | type }}
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column label="状态" width="100px">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ Number(scope.row.state) === 1 ? "必填" : "选填" }}
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column label="操作" width="200px">
                        <template slot-scope="scope" v-if="scope.$index > 2">
                            <div class="table-operate">
                                <el-button
                                    size="medium"
                                    type="primary"
                                    @click="editItem(scope.$index)"
                                >编辑
                                </el-button>
                                <el-button
                                    size="medium"
                                    type="danger"
                                    @click="deleteItem(scope.$index)"
                                >删除
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="flex align-center justify-around margin-tb">
                    <el-button
                        type="primary"
                        @click="signupDialog = true"
                        style="width: 200px"
                    >添加
                    </el-button
                    >
                </div>
            </el-form-item>
            <el-form-item>
                <el-button
                    v-if="!noticeId"
                    style="width: 220px"
                    class="padding-lr-xl"
                    type="primary"
                    @click="submitForm('noticeForm')"
                >发布
                </el-button
                >
                <el-button
                    v-else
                    style="width: 220px"
                    class="padding-lr-xl"
                    type="primary"
                    @click="upDataForm('noticeForm')"
                >更新
                </el-button
                >
            </el-form-item>
        </el-form>
        <signup-dialog
            :setIndex="setIndex"
            :setItem="setItem"
            :signupDialog="signupDialog"
            @cancelDialog="cancelDialog"
        />
        <chiose-dialog
            :chioseType="chioseType"
            :chioseDialog="chioseDialog"
            @cancelChiose="cancelChiose"
            @saveChiose="saveChiose"
        />
    </div>
</template>

<script>
import ChioseDialog from './children/chioseDialog'
import VueUditorWrap from 'vue-ueditor-wrap'
import {bdEditConfig} from "@/utils/utils"
import {SHOWHOST, UDHOST} from '@/config/index'
import signupDialog from '@/views/admin/children/signupDialog'
import chioseDialog from '@/views/admin/children/chioseDialog'
import {noticeAdd, noticeDetail, noticeEdit} from '@/api/admin'

export default {
    name: "noticeEdit",
    data() {

        var validateUser = (rule, value, callback) => {
            if (value.length === 0 && !this.allChiose) {
                callback(new Error('请选择发送会员'));
            } else {
                callback();
            }
        };
        return {
            noticeId: '',
            myConfig: bdEditConfig(),
            noticeForm: {
                title: '',
                content: '',
                attached_file: [],
                notice_type: 1,
                send2user: [],
                delivery: false,
                total: 0,
                signup_num: 1,
                is_send_sms: 0,
                diy_form: [
                    {type: 1, name: "机构名称", state: 1, option: [], value: ''},
                    {type: 1, name: "联系人", state: 1, option: [], value: ''},
                    {type: 1, name: "联系人电话", state: 1, option: [], value: ''},
                ]
            },
            rules: {
                title: [
                    {required: true, message: '请输入通知标题', trigger: 'blur'},
                ],
                content: [
                    {required: true, message: '请输入通知文本', trigger: 'blur'},
                ],
                notice_type: [
                    {required: true, message: '请选择通知类型', trigger: 'change'}
                ],
                send2user: [
                    {required: true, validator: validateUser, trigger: 'change'}
                ],
                delivery: [
                    {required: true, message: '请选择总报名人数是否限制', trigger: 'change'}
                ],
                total: [
                    {required: true, message: '请填写总报名人数是否限制', trigger: 'blur,change'}
                ],
                signup_num: [
                    {required: true, message: '请选择企业报名人数限制', trigger: 'change'}
                ],
                is_send_sms: [
                    {required: true, message: '请选择是否短信通知', trigger: 'change'}
                ],
            },
            fileList3: [],
            allChiose: false,
            signupDialog: false,
            setIndex: -1,
            setItem: {},
            chioseDialog: false,
            chioseType: 1
        }
    },
    computed: {
        udhost() {
            return UDHOST
        },
        showhost() {
            return SHOWHOST
        },
        fileData() {
            return {
                // token: this.user.token
            };
        },
        user() {
            return this.$store.state.user
        },
    },
    created() {
        this.$emit("setIndex", '/admin/notice', "通知公告  /  编辑", true, 'icon-gonggao');
        this.noticeId = Number(this.$route.params.id)
        if (this.noticeId) this.getDetail()
    },
    components: {
        ChioseDialog, VueUditorWrap, signupDialog, chioseDialog
    },
    methods: {

        //  获取通知公告内容
        async getDetail() {
            let _data = await noticeDetail(this.noticeId)
            this.noticeForm.title = _data.data.notice.title
            this.noticeForm.content = _data.data.notice.content
            this.noticeForm.notice_type = Number(_data.data.notice.notice_type)
            this.noticeForm.attached_file = JSON.parse(_data.data.notice.attached_file)
            this.fileList3 = JSON.parse(_data.data.notice.attached_file)

        },
        async upData() {
            let _state = await noticeEdit(
                this.noticeForm.title,
                this.noticeForm.content,
                JSON.stringify(this.noticeForm.attached_file),
                this.noticeId
            )
            if (_state.status === 200) {
                this.$message.success('发布成功')
                this.$router.go(-1)
            } else {
                this.$message.error(_state.msg)
            }
        },
        //  更新通知公告
        upDataForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.upData()
                } else {
                    this.$message.error('通知公告信息未填写完整，请检查！')
                }
            });
        },


        async submitData() {
            let _state = await noticeAdd(
                this.noticeForm.title,
                this.noticeForm.content,
                JSON.stringify(this.noticeForm.attached_file),
                this.noticeForm.notice_type,
                this.allChiose ? 0 : this.noticeForm.send2user.join(','),
                this.noticeForm.notice_type === 3 ? this.noticeForm.total : 0,
                this.noticeForm.notice_type === 3 ? this.noticeForm.signup_num : '',
                this.noticeForm.notice_type === 3 ? this.noticeForm.is_send_sms : 0,
                this.noticeForm.notice_type === 3 ? JSON.stringify(this.noticeForm.diy_form) : '',
            )
            if (_state.status === 200) {
                this.$message.success('发布成功')
                this.$router.go(-1)
            } else {
                this.$message.error(_state.msg)
            }
        },
        //  发布通知公告
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitData()
                } else {
                    this.$message.error('通知公告信息未填写完整，请检查！')
                }
            });
        },


        //  标签选择保存发送人员
        saveChiose(val) {
            this.chioseType = val[0]
            this.noticeForm.send2user = val[1]
            this.cancelChiose()
        },
        //  关闭弹框
        cancelChiose() {
            this.chioseDialog = false
        },
        //  编辑表单项
        editItem(index) {
            this.setItem = this.noticeForm.diy_form[index];
            this.setIndex = index;
            this.signupDialog = true;
        },
        //  删除表单项
        deleteItem(index) {
            this.$confirm("确定要删除吗？", "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                cancelButtonClass: "msg-btn",
                confirmButtonClass: "msg-btn",
                center: true
            }).then(() => {
                this.noticeForm.diy_form.splice(index, 1)
            });
        },
        //  关闭表单弹窗
        cancelDialog(val) {
            if (val[0]) {
                if (this.setIndex === -1) {
                    this.noticeForm.diy_form.push(val[1])
                } else {
                    this.$set(this.noticeForm.diy_form, this.setIndex, val[1])
                }
            }
            this.setIndex = -1;
            this.setItem = {};
            this.signupDialog = false;


        },
        //  上传成功
        handleAvatarSuccess3(res, file) {
            if (res.status === 200) {
                this.noticeForm.attached_file.push(
                    {
                        name: file.name,
                        url: res.url
                    }
                )
                this.fileList3 = this.noticeForm.attached_file
            } else {
                this.$message.error(res.info)
                this.$refs['upload3'].clearFiles()
            }
        },
        // 上传失败
        handleExceed() {
            this.$message.error('上传失败，请重新上传！')
        },
        //上传文件预览
        handlePreview(file) {
            window.open(file.url)
        },
    },
    filters: {
        type(num) {
            switch (Number(num)) {
                case 1:
                    return '单行文本'
                case 2:
                    return '多行文本'
                case 3:
                    return '单选题'
                case 4:
                    return '多选题'
            }
        }
    },
    watch: {
        'noticeForm.delivery'() {
            if (this.noticeForm.delivery && !this.noticeForm.total) {
                this.noticeForm.total = 1
            } else if (!this.noticeForm.delivery) {
                this.noticeForm.total = 0
            }
        }
    },
}
</script>

<style scoped lang="scss">
.sign-up-box {
    position: relative;
    padding-right: 150px;
    min-height: 200px;

    .right-btn {
        position: absolute;
        right: 0;
        bottom: 0;

        .el-button {
            width: 100px;
            margin-bottom: 10px;
        }
    }
}

.table-item {
    p {
        min-width: 100px;

        span {
            color: #e4396c;
        }
    }

    input {
        display: block;
        height: 40px;
        padding: 0 10px;
        border: 1px solid #eee;
        margin-left: 10px;
    }

    input.radio {
        margin: 0;
    }

    textarea {
        display: block;
        border: 1px solid #eee;
        height: 60px;
        padding: 0 10px;
        margin-left: 10px;
    }
}
</style>